import { Typography } from '@cobliteam/ui/components';
import type React from 'react';
import type { TimeMark } from '../types';

interface TimeMarksProps {
  timeMarks: TimeMark[];
}

const TimeMarks: React.FC<TimeMarksProps> = ({ timeMarks }) => {
  return (
    <div className='relative mt-2 h-[40px]'>
      {timeMarks.map(({ position, time }) => (
        <div key={time} className='absolute' style={{ left: `${position}%` }}>
          <div className='mb-1 h-2 w-px bg-gray-6' />
          <Typography variant='caption-default' className='-translate-x-1/2 whitespace-nowrap' color='secondary'>
            {time}
          </Typography>
        </div>
      ))}
    </div>
  );
};

export default TimeMarks;
